import { render } from "./PeersPartial.vue?vue&type=template&id=36ba15b8&scoped=true"
import script from "./PeersPartial.vue?vue&type=script&lang=js"
export * from "./PeersPartial.vue?vue&type=script&lang=js"

import "./PeersPartial.vue?vue&type=style&index=0&id=36ba15b8&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ba15b8"]])

export default __exports__